import { render, staticRenderFns } from "./AllReceivablesTableOperation.vue?vue&type=template&id=33748c90&"
import script from "./AllReceivablesTableOperation.vue?vue&type=script&lang=js&"
export * from "./AllReceivablesTableOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports